import { FlowDefinition } from "../../interfaces/FlowInterfaces";
import { IOrganizationSignUpFlowValues } from "../_interfaces/IOrganizationSignUpFlowValues";
import { AccountDetailsStep } from "../components/steps/AccountDetailsStep";
import { LoginStep } from "../components/steps/LoginStep";
import { MainOrganizationDetailsStep } from "../components/steps/MainOrganizationDetailsStep";
import { OrganizationProfileLimitStep } from "../components/steps/OrganizationProfileLimitStep";
import { OrganizationSignUpSuccessRedirectionStep } from "../components/steps/OrganizationSignUpSuccessRedirectionStep";
import { OrganizationSignUpTermsOfServiceStep } from "../components/steps/OrganizationSignUpTermsOfServiceStep";
import { OrganizationSignUpTriageStep } from "../components/steps/OrganizationSignUpTriageStep";
import { SecondaryOrganizationDetailsStep } from "../components/steps/SecondaryOrganizationDetailsStep";
import { VerifyCorrectAccountStep } from "../components/steps/VerifyCorrectAccountStep";

export type StepIds =
  | "triager"
  | "mainOrganizationDetails"
  | "secondaryOrganizationDetails"
  | "accountDetails"
  | "login"
  | "existingAccountConfirmation"
  | "termsOfService"
  | "organizationProfileLimit"
  | "successRedirection";

export const OrganizationSignUpFlowDefinition: FlowDefinition<
  StepIds,
  IOrganizationSignUpFlowValues
> = {
  initialStep: "triager",
  steps: {

    triager: {
      id: "triager",
      render: OrganizationSignUpTriageStep,
      // TODO: Update
      // isComplete: (v) => ({
      //   valid: !!v.username,
      //   reason: "Please enter a username",
      // }),
      onSubmit: (v) =>
        v.hasExistingOrganizationProfile
          ? { type: "goto", stepId: "organizationProfileLimit" }
          : { type: "goto", stepId: "mainOrganizationDetails" }
    },

    organizationProfileLimit: {
      id: 'organizationProfileLimit',
      render: OrganizationProfileLimitStep,
      onSubmit: (v) =>
        !v.hasExistingOrganizationProfile
          ? { type: "goto", stepId: "mainOrganizationDetails" }
          : { type: "end" }
    },

    mainOrganizationDetails: {
      id: "mainOrganizationDetails",
      render: MainOrganizationDetailsStep,
      onSubmit: (v) => { return { type: "goto", stepId: "secondaryOrganizationDetails" } }
    },

    secondaryOrganizationDetails: {
      id: "secondaryOrganizationDetails",
      render: SecondaryOrganizationDetailsStep,
      onSubmit: (v) =>
        v.backClicked
          ? { type: "goto", stepId: "mainOrganizationDetails" }
          : v.isAuthenticated
            ? { type: "goto", stepId: "existingAccountConfirmation" }
            : { type: "goto", stepId: "accountDetails" }
    },

    accountDetails: {
      id: "accountDetails",
      render: AccountDetailsStep,
      onSubmit: (v) =>
        v.backClicked
          ? { type: "goto", stepId: "secondaryOrganizationDetails" }
          : v.hasAccount
            ? { type: "goto", stepId: "login" }
            : { type: "goto", stepId: "successRedirection" }
    },

    login: {
      id: 'login',
      render: LoginStep,
      onSubmit: (v) =>
        v.backClicked
          ? { type: "goto", stepId: "secondaryOrganizationDetails" }
          : v.hasExistingOrganizationProfile
            ? { type: "goto", stepId: "organizationProfileLimit" }
            : !v.hasAccount
              ? { type: "goto", stepId: "accountDetails" }
              : { type: "goto", stepId: "termsOfService" }
    },

    existingAccountConfirmation: {
      id: 'existingAccountConfirmation',
      render: VerifyCorrectAccountStep,
      onSubmit: (v) =>
        v.backClicked
          ? { type: "goto", stepId: "secondaryOrganizationDetails" }
          : v.correctAccount
            ? { type: "goto", stepId: "termsOfService" }
            : { type: "goto", stepId: "accountDetails" }
    },

    termsOfService: {
      id: 'termsOfService',
      render: OrganizationSignUpTermsOfServiceStep,
      onSubmit: (v) =>
        v.backClicked
          ? v.isAuthenticated
            ? { type: "goto", stepId: "existingAccountConfirmation" }
            : { type: "goto", stepId: "accountDetails" }
          : { type: "goto", stepId: "successRedirection" }
    },

    successRedirection: {
      id: 'successRedirection',
      render: OrganizationSignUpSuccessRedirectionStep,
      onSubmit: (v) => { return { type: "end" } }

    },
  },
};
